import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/es';
import classNames from 'classnames';
import { DETAIL_TURN } from '../../routes/path';

const CardMyTurns = ({ turn, isDisabled }) => {
  const {
    medico,
    turno: { fecha_hora: date },
    estado: status
  } = turn;
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  const fecha = moment(date).locale('es').format('dddd DD/MM/YYYY');
  const hours = moment(date).locale('es').format('HH:mm');

  const handleHover = () => {
    setIsHovered(!isHovered);
  };

  const navigateTo = () => {
    navigate(DETAIL_TURN, { state: { ...turn, isDisabled } });
  };

  return (
    <div
      onClick={() => {
        navigateTo();
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          navigateTo();
        }
      }}
      role="button"
      tabIndex={0}
    >
      <div
        className={classNames('container-my-cardTurns', {
          'container-my-cardTurns--hovered': isHovered, past: isDisabled, confirmed: status === 'confirmada', canceled: status === 'cancelada'
        })}
        defaultValue="placeholder"
        onMouseEnter={handleHover}
        onMouseLeave={handleHover}
      >
        <img
          src={`${process.env.REACT_APP_BACKEND_URL}${medico.foto_sm_url}`}
          alt={`Dr. ${medico.nombre} ${medico.apellido}`}
          className="cardMyTurnBefore-doctor"
        />
        <div className="myTurns-date">
          <div>
            <h2>
              {`* ${medico.nombre} ${medico.apellido}`}
            </h2>
          </div>
          <div>
            <h4>
              <h4>{fecha}</h4>
              <h4>{hours}</h4>
            </h4>
          </div>
        </div>
        <div className="myTurns-state">
          <h4>Estado:</h4>
          <h3>
            {status.toUpperCase()}
          </h3>
        </div>
      </div>

    </div>
  );
};

CardMyTurns.propTypes = {
  turn: PropTypes.shape({
    medico: PropTypes.shape({
      id: PropTypes.number,
      nombre: PropTypes.string,
      apellido: PropTypes.string,
      foto_sm_url: PropTypes.string

    }),
    turno: PropTypes.shape({
      fecha_hora: PropTypes.string,
    }),
    obra_social: PropTypes.shape({
      id: PropTypes.number,
      nombre: PropTypes.string,
    }),
    estado: PropTypes.string
  }).isRequired,
  isDisabled: PropTypes.bool
};

CardMyTurns.defaultProps = {
  isDisabled: false,
};

export default CardMyTurns;
